export const FaqData = [
    {
        question: 'WHAT ARE NFTs? - CAN YOU BREAK IT DOWN FOR ME?',
        answer: <a className="hover:text-red-200 hover:underline" href="https://twitter.com/purisima_pixels/status/1512372866511257603?s=20&t=I5wkcgDhLagWwuXV0sijJQ">NFTs Explained To A 4-Year-Old</a>,
    },
    {
        question: 'HOW DO I PURCHASE AN NFT ITEM?',
        answer: <a className="hover:text-red-200 hover:underline" href="https://www.youtube.com/watch?app=desktop&v=NNQLJcJEzv0">NFTs Explained In 5-Mins</a>,
    },
    {
        question: 'HOW DO I LIST MY NFT?',
        answer: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Incidunt, soluta. Nesciunt soluta eos praesentium culpa inventore modi veritatis voluptatem illum aliquid ducimus nulla debitis, ratione pariatur, eaque a, ullam natus.'
    },
    {
        question: 'WOOOOO...YOU SEF DON TRY. LEAVE NFT',
        answer: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Incidunt, soluta. Nesciunt soluta eos praesentium culpa inventore modi veritatis voluptatem illum aliquid ducimus nulla debitis, ratione pariatur, eaque a, ullam natus.'
    },
    {
        question: 'BROOOOO...YOU NO GO LIKE FIND WORK? ABEG COMOT THIS SIDE I NO DEY ANSWER QUESTION AGAIN',
        answer: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Incidunt, soluta. Nesciunt soluta eos praesentium culpa inventore modi veritatis voluptatem illum aliquid ducimus nulla debitis, ratione pariatur, eaque a, ullam natus.'
    },
]